import Highway from '@dogstudio/highway'
import store from '@js/modules/store'
import { markets } from '@js/modules/blocks'

export default class HomeRenderer extends Highway.Renderer {
    onEnter() {
        const page = this.wrap.lastElementChild

        // Launch global renderer
        store.globalRenderer.onEnter(page)
    }
    onEnterCompleted() {
        const page = this.wrap.lastElementChild

        // Animations
	    if(window.innerWidth >= 1024) {
            // Heading 1
            store.animizi.addHeading1(page.querySelector('.a-heading.-h1'), 0.75)
            // Home block
            store.animizi.addHeading2(page.querySelector('.o-block.-home .a-heading.-h2'))
        }

        // Iterate over global blocks and init them
        const blocks = page.querySelectorAll('.o-block[data-type]')
        blocks.forEach(block => {
            switch (block.dataset.type) {
                case 'markets':
                    markets(block)
                    break
            }
        })

        // Launch global renderer
        store.globalRenderer.onEnterCompleted(page)
    }
    onLeave() {
        // Launch global renderer
        store.globalRenderer.onLeave()
    }
    onLeaveCompleted() {
        // Launch global renderer
        store.globalRenderer.onLeaveCompleted()
    }
}